<template>
  <section class="ml-0 pl-0 info w-100 col-sm-12">
    <main :class="fullView ? 'main' : 'col-12 p-0'">
      <Modal :resizable="true" :scrollable="true" :max-width="700" height="auto" width="80%" style="z-index: 10"
        class="modal-preview p-4" name="newcontact">
        <div class="m-4" v-if="opportunity">
          <NewBusinessContact @refresh="refresh()" :business="opportunity.business"
            :client_id="opportunity.link.client_id" :link_id="opportunity.link.id">
          </NewBusinessContact>
        </div>
      </Modal>

      <!-- @before-open="onModalBeforeOpen" -->
      <modal 
      :resizable="false" 
      :scrollable="false" 
      :max-width="600" 
      height="auto" 
      :size="'600px'" 
      :close="false"
      style="z-index: 10"
      class="modal-preview p-4" 
      name="registerClaimToMeeting"      
      @opened="onModalOpenedClaims">
      
      <!-- div loading -->
      <div class="p-0 m-0">
        <LoadingSpinner v-if="loadingOptionsClaims" />
        <div v-else class="p-4 my-4 text-center text-secondary">
          <div v-if="!showMessageWithoutEvents && eventsToThisOpportunity.length > 0">
            <h5 class="my-4">
              {{ $t("lang.label.complaint_form") }}
            </h5>
              <!-- select list of possible meetings -->          
            <p class="text-left mb-3">{{ $t("lang.label.select_a_meeting") }}</p>
            <select v-model="claim.link_event_id" class="form-control">              
              <option :value="null" disabled>{{ $t("lang.label.select_option") || "Seleccione una opción" }}</option>
              <option v-for="event in eventsToThisOpportunity" :key="event.link_event_id" :value="event.link_event_id">
                {{ event.contact_complete_name }} - {{ new Date(event.event_date).toLocaleString() }}
              </option>
            </select>

            <!-- select to possible claims   -->           
            <p class="text-left mt-3 mb-2">{{ $t("lang.label.complaint_form_q1") }}</p>            
            <select v-model="claim.claim_reason_id" class="form-control">
              <option :value="null" disabled>{{ $t("lang.label.select_option") || "Seleccione una opción" }}</option>
              <option v-for="claim in claimOptions" :key="claim.id" :value="claim.id">              
                {{ $t(`lang.menu.${claim.title}`) }}
              </option>
            </select>

            <div v-if="isIncorrectOptionSelected" class="alert alert-warning mt-3 p-3" style="border-left: 4px solid #ffc107;">
              <p class="text-left mb-2 font-weight-bold" style="font-size: 0.9rem;">
                Disclaimer:
              </p>
              <p class="text-left mb-0" style="font-size: 0.85rem;">
                {{ incorrectOptionMessage }}
              </p>
            </div>

            <p class="text-left mt-3 mb-2">{{ $t("lang.label.complaint_form_q2") }}</p>
            <textarea type="text" class="form-control text-color mt-0"
                  id="details" v-model="claim.details"
                  rows="3"
                  maxlength="200"
                  placeholder="Max. 200 characters" 
                  required="true"
                  :disabled="isIncorrectOptionSelected">
            </textarea>

            <div class="d-flex justify-content-end mt-3">
            <button 
              class="btn btn-secondary mr-2" 
              @click="closeAttendanceModal"
              :disabled="loadingAttendanceStatus"
            >
              {{ $t("lang.button.cancel") }}
            </button>
            <button 
              class="btn btn-primary" 
              @click="saveClaim"
              :disabled="!isClaimFormValid || loadingOptionsClaims || isIncorrectOptionSelected"
            >
              <span
                class="mr-2"
              ></span>
              {{ $t("lang.button.save") }}
            </button>

          </div> 
          
        </div>    
        <div v-else>
            <p class="my-3">
              {{ $t("lang.label.there_not_meetings") }}
            </p>
            <button 
              class="btn btn-secondary mr-2" 
              @click="closeAttendanceModal"
              :disabled="loadingAttendanceStatus"
            >
              {{ $t("lang.button.cancel") }}
            </button>
            
          </div>          
        </div>
      </div>      
    </modal>

      <Modal name="modalModMeet" class="modal-preview p-2" :size="'50'" :close="true" height="100" style="z-index: 10">
        <!-- evaluation task of booker   -->
        <div class="px-5 mt-4 w-100">
          <div class="row mb-2 w-100">
            <div class="col-md-12">
              <div class="row mb-4">
                <div class="col-md-12 pb-5">
                  <div class="d-flex align-items-center">
                    <select
                      v-model="selectedTask"
                      class="form-control flex-grow-1 mr-1"
                    >
                      <option disabled value="null">Search and select the task</option>
                      <option
                        v-for="task in taskOptions"
                        :key="task.id"
                        :value="task.id"
                      >
                        {{ task.label }}
                      </option>
                    </select>
                  </div>
                  <button
                    class="btn btn-success btn-md mt-1 w-100"
                    @click="modifyMeeting(selectedTask, meeting, $route.params.id)"
                    :disabled="!selectedTask"
                  >
                    <span>{{ $t("lang.button.assign_meeting") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <LoadingOliver v-if="loading" />
      <div v-else :class="fullView ? 'pt-5' : ''">
        <div v-if="
          (adminTeam() || !permissionFront()) &&
          opportunity.link.link_status_id == 8 &&
          opportunity.link.link_status_reason_id == 34
        " class="p-2 m-3 rounded bg-danger">
          <small class="text-white">{{ $t("lang.refuse.refusewarning") }}
          </small>
        </div>
        <div v-if="
          (adminTeam() || !permissionFront()) &&
          opportunity.link.link_status_id == 8 &&
          opportunity.link.link_status_reason_id == 35
        " class="p-2 m-3 rounded bg-warning">
          <small class="text-white">{{ $t("lang.refuse.absent") }} </small>
        </div>

        <modal
          :resizable="true"
          :scrollable="true"
          :max-width="700"
          height="auto"
          width="80%"
          style="z-index: 10"
          class="modal-preview p-4"
          name="managerCalendarEvents"
        >
          <div class="p-4">
            <h5 class="mb-3 font-weight-bold">Manager events</h5>

            <div class="mb-3">
              <h4 class="mb-2">Create a meeting with:</h4>
              <select v-model="selectedEventsOptionValue" class="form-control" :disabled="loadingManagerEvents">
                <option
                  v-for="opt in eventsModalSelectOptions"
                  :key="opt.value"
                  :value="opt.value"
                >
                  {{ opt.label }} ( {{ opt.email }})
                </option>
              </select>
            </div>

            <div class="row align-items-end mb-3">
              <div class="col-md-4">
                <label class="small font-weight-bold text-secondary mb-1">{{ $t('lang.calendar.event_from_date') }}</label>
                <input
                  v-model="managerEventsFromDate"
                  type="datetime-local"
                  class="form-control form-control-sm"
                  :disabled="loadingManagerEvents"
                />
              </div>
              <div class="col-md-4">
                <label class="small font-weight-bold text-secondary mb-1">{{ $t('lang.calendar.event_to_date') }}</label>
                <input
                  v-model="managerEventsToDate"
                  type="datetime-local"
                  class="form-control form-control-sm"
                  :disabled="loadingManagerEvents"
                />
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  :disabled="loadingManagerEvents || !selectedEventsOptionValue"
                  @click="fetchManagerCalendarEvents"
                >
                  <i class="icon-refresh mr-1" v-if="!loadingManagerEvents"></i>
                  {{ loadingManagerEvents ? '...' : $t('lang.calendar.event_load_events') }}
                </button>
              </div>
            </div>

            <LoadingSpinner v-if="loadingManagerEvents" />
            <template v-else>
              <p v-if="!managerCalendarEvents || managerCalendarEvents.length === 0" class="text-secondary mb-0">
                {{ $t('lang.calendar.event_no_events_in_range') }}
              </p>
              <div v-else>
                <CalendarEvent
                  v-for="(evt, idx) in managerCalendarEvents"
                  :key="evt.id || idx"
                  :event="evt"
                />
              </div>
            </template>
            <div class="mt-3 text-right">
              <button type="button" class="btn btn-secondary" @click="closeModal('managerCalendarEvents')">
                {{ $t("lang.button.close") }}
              </button>
            </div>
          </div>
        </modal>

        <modal
          :resizable="true"
          :scrollable="true"
          :max-width="980"
          height="auto"
          width="85%"
          style="z-index: 10"
          class="modal-preview p-4"
          name="meetingAnalysisModal"
          @opened="onMeetingAnalysisModalOpened"
        >
          <MeetingRecordings
            ref="meetingRecordings"
            :opportunity-id="opportunity_id"
            :opportunity="opportunity || {}"
            @records-updated="onMeetingRecordsUpdated"
          />
        </modal>

        <modal :resizable="true" :scrollable="true" :max-width="700" height="auto" width="80%" style="z-index: 10"
          class="modal-preview p-4" name="calendar">
          <div class="p-4 my-4 text-center text-secondary">
            <div class="mb-4">
              <h4>Search events for:</h4>
              <select v-model="currentBusinessContact" @change="getSpeach(false)" class="form-control">
                <option v-for="(status, i) in opportunity.business_contacts" :key="status.id" :value="status">
                  {{ status.name }} ( {{ status.email }})
                </option>
              </select>
            </div>
            <div v-if="!checkCalendly()">
              <EmbedCalendar v-if="opportunity.link.user_id" :currentBusinessContact="currentBusinessContact"
                :lastHumanResponse="opportunity.last_human_response"
                :businessName="opportunity.business.name" :user_id="opportunity.link.user_id"
                :link_hash="getLinkId()" />
            </div>

            <div v-if="checkCalendly()">
              <iframe :src="opportunity.campaignTokens.my_calendar_link.value" frameborder="0"
                style="width: 100%; height: 1000px"></iframe>
            </div>
          </div>
        </modal>

        <modal
          name="callPromptInspectModal"
          class="modal-preview p-3"
          :resizable="true"
          height="auto"
          width="92%"
          :scrollable="true"
          :max-width="1400"
          style="z-index: 20"
        >
          <div class="p-3 text-left">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="mb-0">{{ $t('lang.label.inspect_call_prompt_title') }}</h5>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="$modal.hide('callPromptInspectModal')"
              >
                {{ $t('lang.button.close') }}
              </button>
            </div>

            <div v-if="loadingCallPromptInspect" class="text-center py-5">
              <span class="loadingres spinner-border loading-spinner"></span>
            </div>

            <div v-else-if="callPromptInspect">
              <p class="small mb-3">
                <strong>{{ $t('lang.label.inspect_call_prompt_template') }}:</strong>
                <code>{{ callPromptInspect.template_key }}</code>
                <span class="text-muted ml-2">({{ callPromptInspect.provider }} / {{ callPromptInspect.model }})</span>
              </p>

              <div v-if="callPromptInspectShortcodes.length" class="mb-4">
                <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_shortcodes') }}</strong>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0">
                    <tbody>
                      <tr v-for="entry in callPromptInspectShortcodes" :key="entry.token">
                        <td class="font-weight-bold text-nowrap align-top" style="width: 22%">{{ entry.token }}</td>
                        <td style="white-space: pre-wrap; font-size: 12px">{{ entry.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_template_raw') }}</strong>
                  <pre class="small border rounded p-3 mb-0 bg-light" style="max-height: 420px; overflow: auto">{{ callPromptInspect.template_raw }}</pre>
                </div>
                <div class="col-md-6 mb-3">
                  <strong class="small d-block mb-2">{{ $t('lang.label.inspect_call_prompt_resolved') }}</strong>
                  <pre class="small border rounded p-3 mb-0 bg-light" style="max-height: 420px; overflow: auto">{{ callPromptInspect.prompt_resolved }}</pre>
                </div>
              </div>
            </div>

            <p v-else class="text-danger mb-0">{{ callPromptInspectError || $t('lang.general.error') }}</p>
          </div>
        </modal>

        <modal name="aiscript" v-if="fromAdminTasks || currentUser.role_id == 1 || isBdrUser" class="modal-preview p-4"
          :resizable="true" height="auto" width="100%" :scrollable="true" :max-width="700" style="z-index: 10">
          <div class="position-relative p-4 my-4 text-center text-secondary">
            <button type="button" class="close position-absolute right-0 top-0" aria-label="Close"
              @click="closeModal('aiscript')">
              <span aria-hidden="true">&times;</span>
            </button>
            <!-- <div v-if="!pushButton">
              <p v-if="currentTask">
                {{ getDescription(currentTask.title) }}
              </p>
              <h3>AI Script</h3>
              <select v-model="currentBusinessContact"  @change="getSpeach(false)" class="form-control">
                <option
                  v-for="(status, i) in opportunity.business_contacts"
                  :key="status.id"
                  :value="status"
                >
                  {{ status.name }} ( {{ status.email }})
                </option>
              </select>

              <button
                v-if="!checkLoading"
                class="btn btn-primary mt-4"
                @click="
                  answersIndex = 99;
                  getSpeach(false);
                "
                :disabled="!currentBusinessContact"
              >
                Generate AI Script
              </button>
            </div> -->

            <!-- <LoadingSpinner v-if="loadingspeach" /> -->

            <!--  Cabezera -->
            <div class="row" v-if="pushButton">
              <div class="col-md-8 text-left">
                <div class="d-flex flex-row">
                  <img :src="existAvatarEnterprice" alt="" class="mr-3 headerModalImg" />
                  <div>
                    <span>{{ $t("lang.label.represented_for") }} :</span>
                    <h4 class="font-weight-bold m-0">
                      {{ opportunity.link.c_name }}
                    </h4>
                    <small class="text-primary"><a :href="opportunity.link.website" target="_blank">{{
                      opportunity.link.website
                    }}</a></small>
                    <div></div>
                  </div>
                  <span>
                    <small class="font-weight-bold">
                      {{
                        showMore
                          ? opportunity.link.short_description
                          : truncatedText
                      }}
                    </small>
                    <button v-if="
                      opportunity.link.short_description != null &&
                      opportunity.link.short_description.length > limit
                    " @click="toggleExpand" :class="showMore
                          ? 'btn btn-danger ml-2 py-0 px-2'
                          : 'btn btn-primary ml-2 py-0 px-2'
                        ">
                      <i :class="showMore ? 'icon-minus' : 'icon-plus'"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div v-if="opportunity.link" class="col-md-4 d-flex justify-content-end">
                <div class="px-5 text-left">
                  <span>{{ $t("lang.label.email_send_for") }} :</span>
                  <h5 class="font-weight-bold m-0">
                    {{ opportunity.link.label_from }}
                  </h5>
                  <small>{{ opportunity.link.email }}</small>
                </div>
              </div>
            </div>
            <hr />

            <ColdCallPrepBar v-if="pushButton" :script="coldCall" />

            <!-- 📌 Menú de Opciones -->
            <div class="row py-3 mt-3" v-if="pushButton">
              <div class="col-3">
                <div class="my-2">
                  <select :key="refreshButtonAI" v-model="selectedBusinessContact" @change="changeBusiness(false)"
                   :disabled="contactsFiltered.length <= 1"
                    class="form-control">
                    <option v-for="status in contactsFiltered" :key="status.id" :value="status">
                      {{ status.name }} ( {{ status.email }})
                    </option>
                  </select>
                  <div class="w-100 text-center p-2 mt-3" v-if="selectedBusinessContact">
                    <!-- <img :src="opportunity.business.avatar ? opportunity.business.avatar : '@/assets/images/emptyperson.png'" alt="contact" class="rounded-circle headerModalImg" /> -->
                    <img src="@/assets/images/emptyperson.png" alt="contact"
                      class="rounded-circle mb-2 headerModalImg" />
                    <strong>
                      <h5 class="mb-1">{{ selectedBusinessContact.name }}</h5>
                    </strong>
                    <div class="mb-2">
                      <small>
                        <h6 class="m-0">
                          {{ selectedBusinessContact.job }}
                        </h6>
                      </small>
                      <div class="mb-1">
                        <span>
                          <h6 class="m-0">
                            {{ opportunity.business.name }}
                          </h6>
                        </span>
                      </div>
                      <div class="d-flex flex-row justify-content-center">
                        <img v-if="opportunity.business.logo" :src="opportunity.business.logo" alt="icon-logo"
                          class="mr-2 rounded bodyModalIcon" />
                        <p>{{ opportunity.business.alias }}</p>
                      </div>
                    </div>
                    <div>
                      <button v-if="selectedBusinessContact.phone" class="btn btn-success px-4 mb-3" @click="call()">
                        <small><i class="icon-phone"></i>
                          {{ selectedBusinessContact.phone }}</small>
                        <br />{{ $t("lang.task.start_call") }}
                      </button>
                      <div v-if="hasPhones">
                        <button v-for="(phone, index) in phoneList" :key="index" class="btn btn-success px-4 mb-3"
                          @click="call(phone)">
                          <small><i class="icon-phone"></i>
                            {{ phone.trim() }}</small><br />
                          {{ $t("lang.task.start_call") }}
                        </button>
                      </div>

                      <!-- <span v-if="
                        !selectedBusinessContact.event_phone &&
                        !selectedBusinessContact.phone
                      " class="text-danger">
                        <button @click="findPhoneNumber(selectedBusinessContact)" class="btn btn-sm btn-primary">
                          {{
                            loadingPhone
                              ? "Searching...Please wait"
                              : "Find phone number"
                          }}
                        </button>
                      </span> -->
                    </div>
                  </div>
                  <hr class="m-0" />
                </div>
                <div class="card">
                  <div class="list-group cc-scroll text-left" style="max-height: 520px">
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 99"
                      :class="answersIndex == 99 ? 'active' : ''">
                      Main Script
                    </a>
                    <template v-if="ccObjections.length">
                      <div class="list-group-item cc-section-title py-1">{{ $t("lang.label.cold_call_script.objections_section") }}</div>
                      <a v-for="(objection, i) in ccObjections" :key="'cc-objection-' + i" href="#"
                        class="list-group-item list-group-item-action" :title="objection.titre"
                        :class="answersIndex == ccObjectionIndex(i) ? 'active' : ''"
                        @click.prevent="answersIndex = ccObjectionIndex(i)">
                        <span class="cc-objection-label">{{ objection.titre }}</span>
                      </a>
                      <div class="list-group-item cc-section-title py-1">{{ $t("lang.label.cold_call_script.general_section") }}</div>
                    </template>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 0"
                      :class="answersIndex == 0 ? 'active' : ''">
                      Je ne suis pas intéréssé
                      <span v-if="this.openAiAnswers[1].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 1"
                      :class="answersIndex == 1 ? 'active' : ''">
                      Envoyez-moi un e-mail
                      <span v-if="this.openAiAnswers[2].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 2"
                      :class="answersIndex == 2 ? 'active' : ''">
                      Numéro de téléphone ?
                      <span v-if="this.openAiAnswers[3].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 3"
                      :class="answersIndex == 3 ? 'active' : ''">
                      Je rentre en réunion
                      <span v-if="this.openAiAnswers[4].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 4"
                      :class="answersIndex == 4 ? 'active' : ''">
                      Nous faisons cela en interne
                      <span v-if="this.openAiAnswers[5].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action" @click="answersIndex = 5"
                      :class="answersIndex == 5 ? 'active' : ''">
                      Je ne suis pas la bonne personne
                      <span v-if="this.openAiAnswers[6].loading"
                        class="loadingres spinner-border loading-spinner ml-2"></span>
                    </a>
                    <!-- <a href="#" class="list-group-item list-group-item-action"
                    @click="answersIndex = 6"
                    :class="answersIndex == 6 ? 'active' : ''">
                    Calendar
                  </a> -->
                  </div>
                </div>
              </div>

              <!-- 📌 Texto del Script -->
              <div class="col-5 cc-col">
                <ColdCallConsignes v-if="pushButton" :text="coldCall && coldCall.cc_consignes" />
                <div class="card p-3 cc-scroll" ref="ccScriptCard" style="max-height: 560px">
                  <ColdCallObjection v-if="ccSelectedObjection" :objection="ccSelectedObjection" />
                  <div v-else-if="!checkLoading && !loadingSpeach && ccShowPitchFallback(getOpenAiResult())" class="text-left">
                    <p class="cc-text font-weight-bold mb-2" style="color: #fd7e14">{{ $t("lang.label.cold_call_script.pitch_fallback") }}</p>
                    <p class="cc-text">{{ ccPitch }}</p>
                  </div>
                  <div v-else-if="answersIndex != 6 && !checkLoading && !loadingSpeach">
                    <pre> {{ getOpenAiResult() }}</pre>
                  </div>
                  <div class="w-50 p-2 m-2" v-else>
                    <span class="loadingres spinner-border loading-spinner ml-2"></span>
                  </div>

                  <div
                    v-if="
                      currentUser.role_id == 1 &&
                      answersIndex != 6 &&
                      !ccSelectedObjection &&
                      !checkLoading &&
                      !loadingSpeach &&
                      selectedBusinessContact
                    "
                    class="d-flex flex-wrap mt-2"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary mr-2 mb-1"
                      @click="inspectCallPrompt()"
                    >
                      {{ $t('lang.label.inspect_call_prompt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary mb-1"
                      :disabled="loadingRegenerateCallScript"
                      @click="regenerateCallScript()"
                    >
                      <span
                        v-if="loadingRegenerateCallScript"
                        class="loadingres spinner-border loading-spinner spinner-border-sm mr-1"
                      ></span>
                      {{ $t('lang.label.regenerate_call_script') }}
                    </button>
                  </div>

                  <strong
                    v-if="
                      !checkLoading &&
                      !getOpenAiPrompt() &&
                      opportunity.link.userBilling
                    "
                    class="text-danger"
                    ><i class="icon icon-warning"></i> The prompt for
                    opportunities in
                    {{  getLanguage(opportunity.link.userBilling.language_id) }}
                    language has not yet been configured. Please inform the
                    person in charge of this.</strong>
                </div>
              </div>

              <!-- 📌 Calendario -->
              <div class="col-4">
                <div class="card p-3">
                  <div v-if="!checkCalendly()">
                    <EmbedCalendar v-if="opportunity.link.user_id" :currentBusinessContact="currentBusinessContact"
                      :lastHumanResponse="opportunity.last_human_response"
                      :businessName="opportunity.business.name" :user_id="opportunity.link.user_id"
                      :link_hash="getLinkId()" />
                  </div>

                  <div v-if="checkCalendly()">
                    <iframe :src="opportunity.campaignTokens.my_calendar_link.value" frameborder="0"
                      style="width: 100%; height: 1000px"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </modal>

        <!-- Opciones para admin tareas -->
        <div class="d-flex mx-3 px-2 py-2" v-if="fromAdminTasks" :style="'background-color:' +
          getTemperatureBgColors('bg') +
          '; color:' +
          getTemperatureBgColors('text')
          ">
          <div class="mb-1 h6 d-flex align-items-center" v-if="opportunity.business">
            <img v-if="opportunity.business.logo" class="mx-3 rounded-circle shadow" :src="opportunity.business.logo"
              height="50px" />
            {{ opportunity.business.name }}
            <span class="ml-2 cursor-pointer" v-if="opportunity.link.id" @click="openOpportunity(opportunity.link.id)">
              ( {{ opportunity.link.id }} )
            </span>
          </div>
          <div class="mx-4 d-flex flex-fill justify-content-between">
            <div class="d-flex flex-column">
              <!-- <p class="font-weight-bold">Situation</p>
              <p v-if="currentTask">
                {{ getDescription(currentTask.title) }}
              </p> -->
              <button :disabled="!currentTask" class="btn btn-primary mt-2 ml-2" @click="
                openModal('aiscript', true),
                getSpeach(false),
                (answersIndex = 99)
                " v-if="getPromptType()">
                {{ $t("lang.button.start_task") }}
              </button>
            </div>

            <div class="d-flex align-items-center">
              <!-- <button
                class="btn btn-primary border px-4 mr-2 "
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                @click="getMoreTasks()"
              >
                <i class="py-2 mr-2 icon-checkmark"></i>
                SKIP TASK
              </button> -->
              <button class="btn btn-primary border px-4 mr-5 dropdown-toggle" type="button" :disabled="!currentTask"
                id="dropdownMenuButton" aria-haspopup="true" ref="btnMenu" aria-expanded="false" data-toggle="dropdown">
                <i class="py-2 mr-2 icon                                                                                                                                    -checkmark"></i>
                Done
              </button>

              <div class="dropdown-menu text-center dropdown-menu-right dropdown-menu-custom"
                aria-labelledby="dropdownMenuButton">
                <div v-if="
                  optionTask === 2 ||
                  optionTask === 3 ||
                  optionTask === 6 ||
                  optionTask === 4 ||
                  (optionTask === 1 && eventSaveLoading) ||
                  (optionTask === 7 && eventSaveLoading) ||
                  (optionTask === 8 && eventSaveLoading) ||
                  (optionTask === 9 && eventSaveLoading) ||
                  (optionTask === 10 && eventSaveLoading) ||
                  (optionTask === 5 && eventSaveLoading)
                ">
                  <div class="d-flex align-items-center justify-content-center" v-if="eventSaveLoading"
                    style="height: 300px">
                    <Loadingcircle :paramloading="paramloading" />
                  </div>

                  <ActivityActionPopup v-else :linkId="opportunity.link.id" :currentTaskFound="currentTaskFound"
                    :optionTask="optionTask" :selectedBusinessContact="selectedBusinessContact"
                    :businessContactsFiltered="contactsFiltered" @closeFormEvent="closeFormEvent"
                    @getMoreTasks="getMoreTasks" />
                </div>
                <div v-else>
                  <a @click.stop="registerTask(1)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-success">
                      Meeting Booked !
                    </p>
                  </a>
                  <a @click.stop="registerTask(2)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-warning">
                      {{ $t("lang.menu.call_back") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(3)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-warning">
                      {{ $t("lang.menu.no_answer") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(4)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-warning">
                      {{ $t("lang.menu.no_phone") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(6)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-warning">
                      {{ $t("lang.menu.neutral") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(7)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-danger">
                      {{ $t("lang.menu.out_of_scope") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(8)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-danger">
                      {{ $t("lang.menu.out_of_scope_company") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(9)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-danger">
                      {{ $t("lang.menu.wrong_contact") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(10)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-danger">
                      {{ $t("lang.menu.invalid_number") }}
                    </p>
                  </a>
                  <a @click.stop="registerTask(5)" class="dropdown-item m-0 p-0" href="#">
                    <p class="m-1 p-2 text-white font-weight-bold bg-danger">
                      {{ $t("lang.menu.no_interest") }}
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Fin Opciones para admin tareas -->

        <RefuseOpportunity v-if="
          refuse &&
          opportunity.link.link_status_reason_id != 35 &&
          opportunity.link.link_status_reason_id != 34
        " @cancel="closeRefuse()" @refused="refused"></RefuseOpportunity>

        <div class="opportunity-detail-layout m-0 p-0">
          <div
            v-if="!refuse"
            class="row animated fadeIn fast mx-0 align-items-stretch opportunity-detail-row"
          >
            <div class="col-md-4 d-flex flex-column opportunity-left-column">
              <div class="opportunity-left-unified-card d-flex flex-column flex-grow-1 min-h-0">
                <div class="opportunity-left-unified-scroll flex-grow-1 min-h-0">
                  <OpportunityAdminPanel
                    v-if="opportunity"
                    :opportunity="opportunity"
                    :from-admin-tasks="fromAdminTasks"
                    :tasks-key="tasksKey"
                    :opportunity-id="opportunity_id"
                    :is-view-admin-task="isViewAdminTask"
                    :permission-front="permissionFront()"
                    :link-id-to-attach.sync="linkIdToAttach"
                    @pending-tasks="pendingTasks($event)"
                    @task-selected="taskSelected($event)"
                    @list-of-tasks="listOfTasks($event)"
                    @check-all-tasks="checkTasksandRemember(opportunity.link.id)"
                    @open-aiscript="
                      openModal('aiscript', true);
                      getSpeach(false);
                      answersIndex = 99;
                    "
                    @open-calendar="openModal('calendar', true)"
                    @attach-event="attachEventToThisOpportunity()"
                    @do-not-contact-business="doNotContactBusiness($event)"
                    @unsuscribe-business="unsuscribeBusiness($event)"
                    @delete-business="deleteBusiness($event)"
                    @positive-business="positiveBusiness($event)"
                    @negative-business="negativeBusiness($event)"
                    @unlock-contacts="unlockContacts($event)"
                    @reload-op="reloadOp($event)"
                    @reload-tasks="reloadTasks($event)"
                    :meeting-preview-record="meetingPreviewRecord"
                    :status-badge="adminMeetingBadge"
                    @open-meeting-analysis="openMeetingAnalysisModal"
                  />
                  <OpportunityLeftPanel
                    v-if="opportunity"
                    :opportunity="opportunity"
                    :current-user="currentUser"
                    :load-event="loadEvent"
                    :meeting-in-claim="MeetingInClaim"
                    :loading-manager-events="loadingManagerEvents"
                    :client-status-is-visible="clientStatusIsVisible"
                    :client-status-text="clientStatusText"
                    @open-modal="openModal"
                    @check-refuse="checkRefuse"
                    @valide="valide"
                    @open-manager-calendar-events="openManagerCalendarEvents"
                    @unlock-contacts="unlockContacts($event)"
                    @changeBusinessContactStatusByLinkId="changeBusinessContactStatusByLinkId($event)"
                    @unsubscribeContact="unsubscribeContact($event)"
                  />
                </div>
              </div>

                  <!-- <button  
                    class="mt-4 btn btn-outline-primary w-100 text-center" 
                    :disabled="opportunity.link.activerefuse == '1' || this.MeetingInClaim == 1 || !loadEvent"
                     v-if="
                      !hasPermissions('adminClients') &&
                      (adminTeam() || !permissionFront()) &&
                      !(
                        opportunity.link.link_status_reason_id == 34 ||
                        opportunity.link.link_status_reason_id == 35
                      )
                    "  
                     @click="openModalClaim('registerClaimToMeeting')"
                  >
                  <Tooltip class="text-center w-100" :text="this.MeetingInClaim == 1
                        ? $t('lang.label.event_has_claim')
                        : opportunity.link.activerefuse == '1'
                      ? $t('lang.opportunities.refuse')
                      :  ''
                    " :width="'auto'">
                    {{ $t("lang.refuse.report_off_target_appt") }}
                  </Tooltip>
                  </button> -->

              <modal name="absent" class="modal-preview p-4" :resizable="true" height="auto" width="50%"
                :scrollable="true" :max-width="400" style="z-index: 10">
                <div class="p-4 text-center">
                  <h2>{{ $t("lang.label.attention") }}</h2>
                  <p>{{ $t("lang.refuse.callplease") }}</p>
                  
                  <div class="pl-2 text-left">
                    <p v-html="$t('lang.refuse.absent_info')">
                    </p>
                    <p v-html="$t('lang.refuse.absent_info_2')">
                    </p>
                    <ul style="list-style-type: disc !important; padding-left: 30px; margin-left: 10px;">
                      <li style="display: list-item; list-style-type: disc;" v-html="$t('lang.refuse.absent_info_3')">
                      </li>
                      <li style="display: list-item; list-style-type: disc;" v-html="$t('lang.refuse.absent_info_4')">
                      </li>
                      <li style="display: list-item; list-style-type: disc;" v-html="$t('lang.refuse.absent_info_5')">
                      </li>
                    </ul>
                    <p v-html="$t('lang.refuse.absent_info_6')">
                    </p>
                    <p v-html="$t('lang.refuse.absent_info_7')">
                    </p>
                  </div>
                  <div class="card m-4 text-center p-4">
                    <h5 class="text-primary">{{ questions.name }}</h5>
                    <div v-for="q in questions.questions_and_answers">
                      <h5 class="text-primary">
                        {{ q.question }}: {{ q.answer }}
                      </h5>
                    </div>
                    <div></div>
                    <div>
                      <div>
                        <input type="checkbox" class="mr-2 cursor-pointer" value="true" v-model="notcall" /><small
                          class="mr-3 icantcall">{{
                            $t("lang.refuse.notcall")
                          }}</small>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button class="btn btn-primary" :disabled="!validateCall()" v-if="
                      (adminTeam() || !permissionFront()) &&
                      !(
                        opportunity.link.link_status_reason_id == 34 ||
                        opportunity.link.link_status_reason_id == 35
                      )
                    " @click="absentContact()">
                      {{ $t("lang.button.ok") }}
                    </button>
                    <button class="ml-4 btn btn-danger" @click="closeModal('absent')">
                      {{ $t("lang.button.cancel") }}
                    </button>
                  </div>
                </div>
              </modal>

              <modal name="linkDescription" class="modal-preview p-4" :resizable="true" height="auto" width="50%"
                :scrollable="true" :max-width="400" style="z-index: 10">
                <div class="p-4 text-left">
                  <h4 class="my-3 text-center text-primary">
                    Description {{ opportunity.link.c_name }}
                  </h4>

                  <h6 class="my-3 font-weight-bold">Seo Description</h6>

                  <p>
                    {{ opportunity.link.seo_description }}
                  </p>

                  <h6 class="my-3 font-weight-bold">Short Description</h6>

                  <p v-html="convertTextToHtml(opportunity.link.short_description)
                    "></p>
                </div>
              </modal>

              <modal name="viewPitch" class="modal-preview p-4" :resizable="true" height="auto" width="60%"
                :scrollable="true" :max-width="500" style="z-index: 10">
                <div class="p-4 my-4 text-center">
                  <h4>Pitch {{ opportunity.link.c_name }}</h4>
                  <p v-if="
                    opportunity.link.website && opportunity.link.website != ''
                  ">
                    <a class="text-primary cursor-pointer" target="_blank" :href="getWebsite(opportunity.link.website)">
                      See website
                    </a>
                  </p>

                  <LoadingSpinner v-if="!loadingCompleted" />

                  <TargetDetail :client="opportunity.link.client_id" :targetId="opportunity.link.target_id"
                    :toShowOpportunity="true" @loadingCompleted="targetServiceLoadingCompleted" />
                </div>
              </modal>
            </div>
            <div class="col-md-8 d-flex flex-column opportunity-right-column">
              <div
                class="d-flex card p-2 flex-column m-0 p-0 opportunity-activity-column"
              >
                <div class="opportunity-actions-slot flex-shrink-0">
                  <OpportunityActions
                    :from-admin-tasks="fromAdminTasks"
                    @createComment="opportunity.timelinePassed.unshift($event)"
                    @addEmail="opportunity.timelinePassed.unshift($event)"
                  />
                </div>

                <div class="flex-grow-1 m-0 p-2 opportunity-timeline-slot">
                  <TimelineInfo :campaignTokens="opportunity.campaignTokens"
                    :timelineComming="opportunity.timelineComming" :timelinePassed="opportunity.timelinePassed"
                    :timelineRecent="opportunity.timelineRecent" :emails="opportunity.emails"
                    :status="opportunity.status" :id="opportunity.timelinePassed.length"
                    :business="opportunity.business" :user_id="opportunity.link.user_id"
                    :activateSpark="opportunity.link.activated_spark" @phone="setPhone($phone)" 
                    @open-modal-mod-meet="configModalMeeting('modalModMeet', $event)"
                    :temperatureBgColors="temperatureBgColors"
                    :show-load-more="showLoadMoreActivities"
                    :loading-more="loadingMoreActivities"
                    @load-more-activities="loadMoreActivities" />

                  <span class="w-100 text-center mt-3 bg-secondary p-2 text-white"
                    v-if="opportunity.timelinePassed.length == 0">
                    {{ $t("lang.refuse.noactivity") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  openaiService,
  businessesService,
  calendlyService,
  adminService,
  opportunitiesService,
  linksService,
  businessContactsService,
  notificationService,
  bookersService,
  monitorService,
} from "@/_services";
import Modal from "@/components/Common/Modal.vue";
import NewBusinessContact from "@/components/Contacts/NewBusinessContact.vue";
import LoadingOliver from "@/components/LoadingOliver.vue";
import EmbedCalendar from "@/components/Calendar/EmbedCalendar.vue";
import CalendarEvent from "@/components/Calendar/CalendarEvent.vue";
import OpportunityAdminPanel from "@/components/Opportunities/OpportunityAdminPanel.vue";
import RefuseOpportunity from "@/components/Opportunities/RefuseOpportunity.vue";
import OpportunityLeftPanel from "@/components/Opportunities/OpportunityLeftPanel.vue";
import ContactEdition from "@/components/Common/ContactEdition.vue";
import ActivityDemoLinksTabs from "@/components/Opportunities/SingleOpportunity/ActivityDemoLinksTabs.vue";
import ActivityInfo from "@/components/Opportunities/SingleOpportunity/ActivityInfo.vue";
import DemoLinksInfo from "@/components/Opportunities/SingleOpportunity/DemoLinksInfo.vue";
import TimelineInfo from "@/components/Opportunities/SingleOpportunity/TimelineInfo.vue";
import OpportunityActions from "@/components/Opportunities/OpportunityActions.vue";
import ActivityActionPopup from "@/components/Opportunities/SingleOpportunity/ActivityActionPopup.vue";
import QualificationButtons from "@/components/Opportunities/SingleOpportunity/QualificationButtons.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import ProporsalOrderDetail from "@/views/ProporsalOrderDetail.vue";
import emptyperson from "@/assets/images/emptyperson.png";
import Phone from "@/components/Common/Phone.vue";
import TargetDetail from "@/components/Targets/TargetDetail.vue";
import $ from "jquery";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import MeetingRecordings from "@/components/Opportunities/MeetingRecordings.vue";
import ColdCallPrepBar from "@/components/ColdCall/ColdCallPrepBar.vue";
import ColdCallConsignes from "@/components/ColdCall/ColdCallConsignes.vue";
import ColdCallObjection from "@/components/ColdCall/ColdCallObjection.vue";
import { coldCallScriptMixin } from "@/components/ColdCall/coldCallScriptMixin";

export default {
  data() {
    return {
      claim: {
        link_event_id: null,
        claim_reason_id: null,
        details: ""
      },
      showMessageWithoutEvents: false,
      MeetingInClaim: null,
      eventsToThisOpportunity:[],
      managerCalendarEvents: [],
      loadingManagerEvents: false,
      managerEventsFromDate: "",
      managerEventsToDate: "",
      managerEventsMonitorList: [],
      selectedEventsOptionValue: null,
      claimOptions: [],
      loadingOptionsClaims: true,
      meetingAnalysisRecords: [],
      meetingRecordingsLoadedForLinkId: null,
      requestedMeetingId: null,
      contactsFiltered: [],
      refreshButtonAI: 2,
      pendingtasks: [],
      listOfTask: [],
      selectedTask: null,
      meeting: null,
      bdrNotificationName: null,
      bdrNotificationId: null,
      task_id: null,
      showMore: false,
      loadingSpeach: false,
      loadingPhone: false,
      limit: 120,
      isMenuOpen: false,
      openprompt: false,
      loadingCallPromptInspect: false,
      loadingRegenerateCallScript: false,
      callPromptInspect: null,
      callPromptInspectError: null,
      callOpenaiprompt: false,
      callOpenaiResult: false,
      selectedBusinessContact: null,
      currentBusinessContact: false,
      currentBusinessContactId: false,
      optionTask: 1,
      cantPendingTask: null,
      buttonTop: 0,
      aiscript: false,
      buttonLeft: 0,
      currentTask: null,
      clientStatus: false,
      contactEdition: false,
      fullView: false,
      myteam: [],
      refuse: false,
      eventid: false,
      questions: false,
      notcall: false,
      tasksKey: 0,
      linkIdToAttach: "",
      loadingCompleted: false,
      isDropdownOpen: false,
      account_id: "",
      eventSaveLoading: false,
      paramloading: {
        width: "38px",
        height: "38px",
        color: "#5054EB",
      },
      loadingTaskTotals: false,
      activities2Offset: 50,
      showLoadMoreActivities: false,
      loadingMoreActivities: false,
      isEventMeeting: false,
      pushButton: true,
      listPendingTasks: [],
      openAiAnswers: [
        {
          answersIndex: 99,
          prompts: false,
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 0,
          prompts: "callprompt_notinterest",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 1,
          prompts: "callprompt_sendemail",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 2,
          prompts: "callprompt_phonenumber",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 3,
          prompts: "callprompt_inmeeting",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 4,
          prompts: "callprompt_intern",
          result: "",
          promptResult: "",
          loading: false,
        },
        {
          answersIndex: 5,
          prompts: "callprompt_norightperson",
          result: "",
          promptResult: "",
          loading: false,
        },
      ],
      answersIndex: 99,
      preAnswers: [
        "Je comprends, pas de souci ! Juste une question rapide avant de raccrocher : comment est-ce que vous traitez ce sujet en interne ?",
        "Pas de souci, je vais suivre vos instructions et vous faire un mail. En revanche, je veux pas vous envoyer un simple template, et je vais prendre le temps de l’écrire, car je veux que vous le lisiez ce mail. Donc : Qu’est-ce que vous voulez voir dedans ? Je vous mets quoi dans l’objet pour que vous pensiez à moi ?",
        "Bonne question ! En fait, j’utilise un outil qui s’appelle Full Enrich, qui permet de récupérer les numéros directement à partir de LinkedIn. C’est comme ça que j’ai pu vous contacter. Mais je comprends que cela vous embête. Si vous le souhaitez, après notre appel je supprime votre numéro et je demande à Full Enrich de faire pareil",
        "Entendu, est-ce que vous pensez que ca serait une perte de temps de vous rappeler plus tard au sujet de X ?",
        "C’est vraiment intéressant que vous l’ayez internalisé. Je suis curieux, est-ce que cela vous a permis d’atteindre tous les résultats que vous visiez, ou pensez-vous qu’il y aurait encore des marges d’amélioration sur certains points ?",
        "Ah super, merci de me le préciser d'entrée de jeu, ça nous fait gagner du temps à tous les deux. Je pense néanmoins que vous pourriez m’aider. Est-ce que vous pourriez m’indiquer qui gère les sujets X en interne ?",
      ],
      temperatureBgColors: [
        {
          id: 1,
          prompt: "callprompt_urgent",
          label: "Urgent",
          bgColor: "#008000",
          textColor: "#FFFFFF",
          description:
            "The prospect appears to be looking to schedule a meeting",
        },
        {
          id: 2,
          prompt: "callprompt_positive",
          label: "Positive",
          bgColor: "#008000",
          textColor: "#FFFFFF",
          description: "The prospect seems open to a meeting",
        },
        {
          id: 3,
          prompt: "callprompt_introduction",
          label: "Introduction",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 4,
          label: "Wrong Contact",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 5,
          label: "Negative",
          bgColor: "#0000FF",
          textColor: "#FFFFFF",
          description: "We received a manual reply from the prospect",
        },
        {
          id: 6,
          prompt: "callprompt_inspection",
          label: "Calendar Inspection",
          bgColor: "#00FFFF",
          textColor: "#000000",
          description: "The prospect has been on the customer's agenda",
        },
        {
          id: 7,
          prompt: "callprompt_absent",
          label: "Reschedule",
          bgColor: "#FFFF00",
          textColor: "#000000",
          description: "Rescheduling a meeting",
        },
        {
          id: 8,
          prompt: "callprompt_cold",
          label: "Cold",
          bgColor: "#C0C0C0",
          textColor: "#FFFFFF",
          description: "No interaction has yet been detected.",
        },
        {
          id: 9,
          prompt: "callprompt_otheranswer",
          label: "Other Answer",
          bgColor: "#FF9966",
          textColor: "#000000",
          description: "We received a manual reply with other answer.",
        },
      ],
    };
  },

  mixins: [coldCallScriptMixin],
  components: {
    ColdCallPrepBar,
    ColdCallConsignes,
    ColdCallObjection,
    EmbedCalendar,
    CalendarEvent,
    NewBusinessContact,
    OpportunityAdminPanel,
    ContactEdition,
    LoadingSpinner,
    ActivityDemoLinksTabs,
    ActivityInfo,
    DemoLinksInfo,
    TimelineInfo,
    LoadingOliver,
    OpportunityActions,
    QualificationButtons,
    RefuseOpportunity,
    Modal,
    Tooltip,
    OpportunityLeftPanel,
    ProporsalOrderDetail,
    ActivityActionPopup,
    Loadingcircle,
    TargetDetail,
    Phone,
    Treeselect,
    MeetingRecordings,
  },

  props: {
    currentTaskFound: Object,
    emails: Object,
    opportunity_id: Number,
    fromAdminTasks: {
      type: Boolean,
      default: false,
    },
    linksFound: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      loading: (state) => state.opportunities.loadingOpportunity,
      opportunity: (state) => state.opportunities.selected.data,
      opportunities: (state) => state.opportunities.all.data,
      currentUser: (state) => state.authentication.user,
      loadEvent: (state) => state.opportunities.loadEvent,
      // prospector: (state) => state.opportunities.prospector,
      //loadProspector: (state) => state.opportunities.loadProspector,
    }),

    adminMeetingBadge() {
      if (!this.currentUser || this.currentUser.role_id != 1) return null;
      if (!this.opportunity || !this.opportunity.link || this.opportunity.link.link_status_id != 8) return null;

      const reasonId = this.opportunity.link.link_status_reason_id;
      if (reasonId == 35) {
        return { label: this.$t("lang.refuse.badge_absent"), class: "admin-meeting-badge-absent" };
      }

      const events = Array.isArray(this.opportunity.events) ? this.opportunity.events : [];
      const lastMeeting = events.find((event) => event.event_id == 3 && event.status != "deleted");
      const lastMeetingCanceled = !!lastMeeting && ["canceled", "cancelled"].includes(lastMeeting.status);

      if (reasonId == 34 || (lastMeetingCanceled && reasonId != 38)) {
        return { label: this.$t("lang.refuse.badge_canceled"), class: "badge-danger" };
      }

      return { label: this.$t("lang.refuse.badge_valid"), class: "badge-success" };
    },

    meetingPreviewRecord() {
      if (Number(this.meetingRecordingsLoadedForLinkId) !== Number(this.opportunity_id)) {
        return null;
      }

      const records = Array.isArray(this.meetingAnalysisRecords) ? this.meetingAnalysisRecords : [];
      if (records.length === 0) return null;

      const record = records[0];
      if (!record || !record.recording_status) return null;

      return record;
    },

    checkLoading() {
      return this.openAiAnswers.some(
        (item) => item.loading && item.answersIndex == this.answersIndex
      );
    },

    callPromptInspectShortcodes() {
      if (!this.callPromptInspect || !this.callPromptInspect.shortcodes) {
        return [];
      }
      return Object.keys(this.callPromptInspect.shortcodes).map((token) => ({
        token,
        value: this.formatShortcodeValue(this.callPromptInspect.shortcodes[token]),
      }));
    },

    hasPhones() {
      return (
        this.selectedBusinessContact &&
        this.selectedBusinessContact.event_phone &&
        this.selectedBusinessContact.event_phone.length > 0
      );
    },
    phoneList() {
      if (!this.selectedBusinessContact.event_phone) return [];
      return this.selectedBusinessContact.event_phone.split(",");
    },

    user() {
      return this.$store.state.authentication.user;
    },
    isClaimFormValid() {
      return (
        this.claim.link_event_id !== null &&
        this.claim.claim_reason_id !== null &&
        this.claim.details &&
        this.claim.details.trim().length > 0 &&
        !this.isIncorrectOptionSelected
      );
    },
    isIncorrectOptionSelected() {
      return this.claim.claim_reason_id && 
             typeof this.claim.claim_reason_id === 'string' && 
             this.claim.claim_reason_id.startsWith('Incorrect_');
    },
    incorrectOptionMessage() {
      if (!this.isIncorrectOptionSelected) return null;
      const messageKey = `lang.label.incorrect_option_${this.claim.claim_reason_id.replace('Incorrect_', '')}`;
      return this.$t(messageKey);
    },
    clientStatusIsVisible() {
      const clientStatusId = this.opportunity.link.client_status_id;
      const statuses = ["4", "5", "7", "8"];
      return statuses.includes(clientStatusId);
    },
    clientStatusText() {
      const clientStatusId = this.opportunity.link.client_status_id;
      const inactive = ["5", "7", "8"];

      if (!inactive.includes(clientStatusId)) {
        this.clientStatus = true;
        return this.$t("lang.label.active");
      } else {
        this.clientStatus = false;
        return this.$t("lang.label.inactive");
      }
    },
    eventsModalSelectOptions() {
      const opts = [];
      const link = this.opportunity && this.opportunity.link;
      if (!link) return opts;
      const seenUserIds = new Set();
      if (link.userBilling && link.userBilling.id != null && !seenUserIds.has(link.userBilling.id)) {
        seenUserIds.add(link.userBilling.id);
        const name = [link.userBilling.name, link.userBilling.lastname].filter(Boolean).join(" ");
        opts.push({
          value: "user_" + link.userBilling.id,
          label: name ? name + " (Manager)" : "Manager",
          email: link.userBilling.email || "",
          userId: link.userBilling.id,
          useAccountId: false,
        });
      }
      if (link.user_id != null && link.owner_name && !seenUserIds.has(link.user_id)) {
        seenUserIds.add(link.user_id);
        opts.push({
          value: "user_" + link.user_id,
          label: link.owner_name + " (Sale)",
          email: link.cn_email || "",
          userId: link.user_id,
          accountId: typeof btoa !== "undefined" ? btoa(String(link.user_id)) : "",
          useAccountId: true,
        });
      }
      if (this.opportunity.link) {
        opts.push({
          value: "user_" + this.opportunity.link.label_from,
          label: this.opportunity.link.label_from + " (Oliverlist Business Developer)",
          email: this.opportunity.link.email || "",
          userId: this.opportunity.link.email || "",
          useAccountId: false,
        });
      }
      const monitorList = this.managerEventsMonitorList || [];
      monitorList.forEach((item) => {
        if (item.id == null || seenUserIds.has(item.id) || item.isFake == "1" || item.child_sales_representative_id != null) return;
        seenUserIds.add(item.id);
        const name = [item.name, item.lastname].filter(Boolean).join(" ").trim() || "User " + item.id;
        opts.push({
          value: "user_" + item.id,
          label: name + " (Monitor)",
          email: item.email || "",
          userId: item.id,
          accountId: typeof btoa !== "undefined" ? btoa(String(item.id)) : "",
          useAccountId: true,
        });
      });
      return opts;
    },
    isBdrUser() {
      const user = this.$store.state.authentication.user;
      return user.team_role_id == 2 && user.role_id == 2;
    },
    getWebsite() {
      return (website) => {
        if (website.includes("http")) {
          return website;
        } else {
          return "https://" + website;
        }
      };
    },
    isViewAdminTask() {
      const currentNamdRoute = this.$route.name;
      return currentNamdRoute == "admin-tasks" ? true : false;
    },

    getDescription() {
      return (text) => {
        const itemFound = this.temperatureBgColors.find(
          (e) => e.id == this.opportunity.link.link_status_temperature_id
        );

        if (itemFound) {
          return itemFound.description;
        }

        return text;
      };
    },

    getTemperatureName() {
      return (text) => {
        const itemFound = this.temperatureBgColors.find(
          (e) => e.id == this.opportunity.link.link_status_temperature_id
        );

        if (itemFound) {
          return itemFound.label;
        }

        return text;
      };
    },

    getTemperatureBgColors() {
      return (item) => {
        const colorFound = this.temperatureBgColors.find(
          (e) => e.id == this.opportunity.link.link_status_temperature_id
        );

        if (colorFound) {
          return item == "bg" ? colorFound.bgColor : colorFound.textColor;
        }

        if (item == "bg") {
          return "#0000FF";
        } else {
          return "#FFFFFF";
        }
      };
    },

    existAvatarEnterprice() {
      if(this.opportunity.link.userBilling){
        var avatar = this.opportunity.link.userBilling.avatar;
        return avatar ? avatar : emptyperson;
      }else{
        return emptyperson;
      }
    },

    truncatedText() {
      return this.opportunity.link.short_description != null &&
        this.opportunity.link.short_description.length > this.limit
        ? this.opportunity.link.short_description.substring(0, this.limit) +
        "..."
        : this.opportunity.link.short_description;
    },

    taskOptions() {
      return this.listOfTask.map(task => {
        const message = this.getParsedMessage(task.message);
        return {
          id: task.id,
          label: `${message ? message.params.bc_name : ""} - ${task.updated} - ${task.task_owner_name}`
        }
      });
    },

  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  created() {
    let opid;
    document.title = this.$t("lang.search.loading") + "...";
    opid = this.opportunity_id;
    //await this.getLeadTasks();

    // if(this.fromAdminTasks){
    //   const pending = this.pendingtasks.find(task => task.notification_status_id === "1");
    //   this.task_id = pending ? pending.id : null;
    // }

    this.fullView = false;
    this.getOpportunityById({ id: opid, notification_id: this.task_id });
    this.disabledEsc();

    if (this.fromAdminTasks) {
      
      this.intervalId = setInterval(() => {
        this.$router.push({ name: "allbdr", params: { item: 5 } });
      }, 1800000); //  20 minutos
    }
  },

  watch: {
    opportunity_id() {
      this.meetingAnalysisRecords = [];
      this.meetingRecordingsLoadedForLinkId = null;
      this.resetActivities2Pagination();
    },

    loading(newValue) {
      if (!newValue) {
        const opportunity = this.$store.state.opportunities.selected.data;
        if (opportunity) {
          this.preloadMeetingRecordingsForBox();

          if (opportunity.business && opportunity.business.name) {
            document.title = opportunity.business.name;
          }
          if (opportunity.events.length > 0) {
            opportunity.events.forEach((element) => {
              if (element.event_id == 3) {
                this.isEventMeeting = true;
              }
            });
          }
          if (opportunity.prompts && Object.keys(opportunity.prompts).length > 0) {
            this.openAiAnswers.forEach((el) => {
              if (el.prompts === false && opportunity.prompts.hasOwnProperty("0")) {
                el.result = opportunity.prompts["0"];
                //el.promptResult = opportunity.prompts["0"];
                el.loading = false;
              } else if (el.prompts && opportunity.prompts.hasOwnProperty(el.prompts)) {
                el.result = opportunity.prompts[el.prompts];
                //el.promptResult = opportunity.prompts[el.prompts];
                el.loading = false;
              } else {
                el.result = "";
                el.promptResult = "";
                el.loading = false;
              }
            });
          }
          this.initActivities2Pagination(opportunity);
        }
      }
    },
    //    el modal ai script inicia con un prospector seleccionado inicialmente evita que este nulo
    "opportunity.business_contacts"(newVal) {
      if (newVal.length > 0 && !this.selectedBusinessContact) {
        this.contactsFiltered = this.getContactsFiltered()
        this.selectedBusinessContact = this.contactsFiltered[0];
      }
    },
  },

  mounted() { 
    if(this.currentUser.role_id == 4){
      this.hasEventInClaim(this.opportunity_id);
    }
  },

  methods: {
    ...mapActions("opportunities", {
      getAll: "getAll",
      getOpportunityById: "getOpportunityById",
      reloadOpportunity: "reloadOpportunity",
      getPriorityOpportunity: "getPriority",
      resetPriorityOpportunity: "resetPriority",
      startLoading: "startLoading",
      finishLoading: "finishLoading",
      setOpportunitySelected: "setOpportunitySelected",
      changeOpportunityStatus: "changeOpportunityStatus",
      setTasks: "setTasks",
    }),

    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    async checkRefuse(){
      const linkId = this.opportunity.link.id
      try {
        const {activerefuse} = await linksService.getActiveRefuse(linkId);
        
        if(activerefuse == "0") {
          this.refuse = true
        } else {
          this.opportunity.link.activerefuse = '1'
        }        

      } catch (error) {
        console.log(error)
      }
    },

    resetActivities2Pagination() {
      this.activities2Offset = 50;
      this.showLoadMoreActivities = false;
      this.loadingMoreActivities = false;
    },

    initActivities2Pagination(opportunity) {
      if (!opportunity) {
        this.resetActivities2Pagination();
        return;
      }
      this.activities2Offset = 50;
      this.showLoadMoreActivities = opportunity.paginationActivities2 === true;
      this.loadingMoreActivities = false;
    },

    loadMoreActivities() {
      if (
        this.loadingMoreActivities ||
        !this.showLoadMoreActivities ||
        !this.opportunity ||
        !this.opportunity.link ||
        !this.opportunity.link.id
      ) {
        return;
      }

      this.loadingMoreActivities = true;
      opportunitiesService
        .getPaginationActivitiesOpportunities(
          this.opportunity.link.id,
          this.activities2Offset,
          51
        )
        .then((res) => {
          if (!res || !res.items) {
            this.showLoadMoreActivities = false;
            return;
          }
          opportunitiesService.appendActivities2ToOpportunity(
            this.opportunity,
            res.items
          );
          this.activities2Offset = res.nextOffset;
          this.showLoadMoreActivities = res.hasMore === true;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingMoreActivities = false;
        });
    },

    openMeetingAnalysisModal(payload = {}) {
      this.requestedMeetingId = payload && payload.meetingId ? Number(payload.meetingId) : null;
      this.$modal.show("meetingAnalysisModal");
    },

    onMeetingAnalysisModalOpened() {
      if (this.$refs.meetingRecordings) {
        this.$refs.meetingRecordings.load({ meetingId: this.requestedMeetingId });
      }
    },

    onMeetingRecordsUpdated({ records, loadedForLinkId }) {
      this.meetingAnalysisRecords = records;
      this.meetingRecordingsLoadedForLinkId = loadedForLinkId;
    },

    async preloadMeetingRecordingsForBox() {
      if (!this.opportunity_id) return;
      if (Number(this.meetingRecordingsLoadedForLinkId) === Number(this.opportunity_id)) return;

      try {
        const result = await opportunitiesService.getMeetingRecordingsAnalysis(this.opportunity_id);
        const records = Array.isArray(result) ? result : [];
        this.meetingAnalysisRecords = records.map((row) => ({
          ...row,
          meeting_recording_id: row.meeting_recording_id != null ? Number(row.meeting_recording_id) : null,
          meetingDisplayLabel: row.meetingDisplayLabel || (() => {
            const value = row.start_time || row.event_date || row.recording_created_at;
            const dateStr = value ? new Date(value).toLocaleString() : "Meeting";
            const ownerName = [row.owner_first_name, row.owner_last_name].filter(Boolean).join(" ").trim();
            const ownerEmail = row.owner_email || "";
            const ownerLabel = ownerName && ownerEmail ? `${ownerName} (${ownerEmail})` : ownerName || ownerEmail || "Sin usuario";
            return `${dateStr} ${ownerLabel}`;
          })(),
        }));
        this.meetingRecordingsLoadedForLinkId = this.opportunity_id;
      } catch (e) {
        // Silent fail — la caja simplemente no se muestra
      }
    },

    hasEventInClaim(opportunityId){
      adminService.getEventInClaim(opportunityId)
        .then(response => {
          this.MeetingInClaim = response.this_event_has_claim;
        })
        .catch(error => {
          console.error("Error fetching events:", error);
        })
    },

    saveClaim(){
      // Validar que todos los campos estén completos
      if (!this.isClaimFormValid) {
        this.$swal.fire("", this.$t("lang.label.fill_all_fields") || "Por favor complete todos los campos", "warning");
        return;
      }

      this.loadingOptionsClaims = true;
      const claimData = {
        link_event_id: this.claim.link_event_id,
        claim_reason_id: this.claim.claim_reason_id,
        details: this.claim.details.trim(),
        status: 'new_claim'
      };

      adminService.saveClaimToMeeting(claimData)
        .then(response => {
          if (response && response.id) {
            this.dispatchClaimJudge(response.id);
          }
          this.closeAttendanceModal();         
          this.$swal.fire("", this.$t("lang.taskGeneration.successful"), "success");
        })
        .catch(error => {
          console.error("Error saving claim:", error);
          this.$swal.fire("", "Error saving claim", "error");
        })
        .finally(() => {
          this.loadingOptionsClaims = false;
        });
    },

    closeAttendanceModal() {
      this.loadingOptionsClaims = true;
      this.claim = {
        link_event_id: null,
        claim_reason_id: null,
        details: ""
      };
      this.showMessageWithoutEvents = false;
      this.$modal.hide("registerClaimToMeeting");     
    },

    onModalOpenedClaims(event) {
      console.log('open modal claims', event)
    },

    getContactsFiltered(){
      if (this.refreshButtonAI > 1) {
        if (
          this.currentTask != null &&
          this.currentTask.business_contact_id != null
        ) {
          const contactFiltered = this.opportunity.business_contacts.filter(
            (el) => el.id == this.currentTask.business_contact_id
          );

          if (contactFiltered.length > 0) {
            this.selectedBusinessContact = contactFiltered[0]
            return contactFiltered;
          } else {
            this.selectedBusinessContact = this.opportunity.business_contacts[0]
            return this.opportunity.business_contacts;
          }
        } else {
          this.selectedBusinessContact = this.opportunity.business_contacts[0]
          return this.opportunity.business_contacts;
        }
      } else {
        this.selectedBusinessContact = this.opportunity.business_contacts[0]
        return this.opportunity.business_contacts;
      }
    },

    toggleExpand() {
      this.showMore = !this.showMore;
    },

    call(phoneNumber) {
      if (phoneNumber) {
        this.callToRingOver(phoneNumber);
      } else if (this.selectedBusinessContact.phone) {
        this.callToRingOver(this.selectedBusinessContact.phone);
      }
    },
    async findPhoneNumber(contact) {
      this.loadingPhone = true;
      let datas = {
        enrich_fields: ["contact.phones"],
      };

      if (
        contact.email &&
        contact.email.substring(contact.email.indexOf("@"))
      ) {
        datas.domain =
          "www." + contact.email.substring(contact.email.indexOf("@") + 1);
      }

      if (contact.name) {
        const parts = contact.name.split(" ");
        const firstName = parts[0];
        const lastName = parts.slice(1).join(" ");

        datas.firstname = firstName;
        datas.lastname = lastName;
      }

      if (contact.linkedinurl) {
        datas.linkedinurl = contact.linkedinurl;
      }

      const dataToFindPhone = {
        name: "SEARCH PHONE REQUEST FRONTEND Oliverlist app",
        business_contacts_id: contact.id,
        datas: [
          {
            ...datas,
          },
        ],
      };

      try {
        const result = await businessContactsService.requestPhoneTofullenrich(
          dataToFindPhone
        );

        // Llamamos a la función que intenta obtener el teléfono con reintentos
        const phoneData = await this.retryGetPhone(contact.id);

        if (phoneData === "empty") {
          let contact_updated;
          this.loadingPhone = false;
          contact_updated = new Date().toISOString();
          contact.source_phone = "FullEnrich";
        } else {
          this.updateBusinessContacts(phoneData);
        }
      } catch (error) {
        console.error("Error al obtener teléfono:", error);
      }
      this.loadingPhone = false;
    },

    async retryGetPhone(contactId, retries = 4, delay = 10000) {
      for (let i = 0; i < retries; i++) {
        const result = await businessContactsService.getcheckPhone(contactId);

        if (result.length > 0) {
          const item = result[0];
          if (item.phone && item.phone != null) {
            return result;
          }
        }

        if (i < retries - 1) {
          await this.delay(delay);
        } else {
          return "empty";
        }
      }
      throw new Error(`No se encontró teléfono para el contacto ${contactId}`);
    },

    updateBusinessContacts(phoneData) {
      this.opportunity.business_contacts.forEach((el) => {
        const phone = phoneData.find(
          (item) => item.business_contact_id === el.id
        );
        if (phone && phone.phone) {
          el.phone = phone.phone;
          el.phone_updated = new Date().toISOString();
          el.source_phone = "FullEnrich";
          el.loadingPhone = false;
        }
      });
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    callToRingOver(ring_to) {
      if (this.opportunity_id) {
        //console.log("RING TO: " + ring_to);
        adminService
          .callRingOver(
            ring_to,
            this.opportunity_id,
            this.selectedBusinessContact.name
          )
          .then((res) => {
            if (res.error) {
              this.$swal.fire("", res.error, "error");
            }
          });
      }
    },
    openCalendar() { },

    refresh() {
      this.getOpportunityById({ id: this.opportunity_id });
      this.closeModal("newcontact");
    },

    openOpportunity(opportunityId) {
      let url = "/opportunities/" + opportunityId;
      window.open(url, "_blank");
    },
    getLanguage(language_id) {
      if (language_id == 4) {
        return "italian";
      }
      if (language_id == 2) {
        return "english";
      }
      if (language_id == 3) {
        return "spanish";
      }
      if (language_id == 5) {
        return "portugues";
      }
    },
    getPromptType() {
      const itemFound = this.temperatureBgColors.find(
        (e) => e.id == this.opportunity.link.link_status_temperature_id
      );

      if (itemFound) {
        return itemFound.prompt;
      }

      return false;
    },
    getOpenAiResult() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      return foundItem ? foundItem.result : null; // Devuelve 'result' si existe, de lo contrario 'null'
    },

    getOpenAiPrompt() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      return foundItem ? foundItem.promptResult : null; // Devuelve 'result' si existe, de lo contrario 'null'
    },

    getCurrentCallPromptParams() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      let callprompt = foundItem && foundItem.prompts ? foundItem.prompts : this.getPromptType();
      return {
        callprompt,
        business_contact_id: this.selectedBusinessContact.id,
        link_id: this.opportunity_id,
        target_id: this.opportunity.link.target_id,
        prospectors_name: this.opportunity.link.label_from,
      };
    },

    formatShortcodeValue(value) {
      if (value === null || value === undefined || value === "") {
        return "(empty)";
      }
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      return String(value);
    },

    inspectCallPrompt() {
      this.callPromptInspect = null;
      this.callPromptInspectError = null;
      this.loadingCallPromptInspect = true;
      this.$modal.show("callPromptInspectModal");

      openaiService.inspectCallPrompt(this.getCurrentCallPromptParams()).then(
        (result) => {
          this.callPromptInspect = result.data || null;
          if (!this.callPromptInspect) {
            this.callPromptInspectError = result.message || null;
          }
          this.loadingCallPromptInspect = false;
        },
        (error) => {
          this.callPromptInspectError =
            typeof error === "string" ? error : this.$t("lang.general.error");
          this.loadingCallPromptInspect = false;
        }
      );
    },

    regenerateCallScript() {
      const foundItem = this.openAiAnswers.find(
        (item) => item.answersIndex == this.answersIndex
      );
      if (!foundItem || !this.selectedBusinessContact) {
        return;
      }

      if (!foundItem.prompts) {
        foundItem.prompts = this.getPromptType();
      }

      this.loadingRegenerateCallScript = true;
      this.loadingSpeach = true;
      foundItem.loading = true;
      foundItem.result = "";
      foundItem.promptResult = "";

      const params = {
        ...this.getCurrentCallPromptParams(),
        force_regenerate: true,
      };

      openaiService.getCallPrompt(params).then(
        (result) => {
          if (!result.data || result.data.length === 0) {
            foundItem.result = result.message || "EMPTY";
          } else {
            foundItem.result = result.data[0].replaceAll("<br>", "\n");
            foundItem.promptResult = result.prompt;
          }
          foundItem.loading = false;
          this.loadingRegenerateCallScript = false;
          this.loadingSpeach = false;
        },
        () => {
          foundItem.loading = false;
          this.loadingRegenerateCallScript = false;
          this.loadingSpeach = false;
        }
      );
    },

    getSpeach(prompt) {
      this.currentBusinessContact = this.selectedBusinessContact;

      this.loadingSpeach = true;
      this.pushButton = true;

      this.openAiAnswers.forEach((item) => {
        item.loading = true;
        if (!item.prompts) {
          item.prompts = this.getPromptType();
        }

        let params = {
          callprompt: item.prompts,
          business_contact_id: this.currentBusinessContact.id,
          link_id: this.opportunity_id,
          target_id: this.opportunity.link.target_id,
          prospectors_name: this.opportunity.link.label_from,
        };
        console.log(item)
        if(item.result ==""){
          openaiService.getCallPrompt(params).then((result) => {
          if (!result || !result.data || result.data.length == 0) {
            this.callOpenaiResult = result && result.message;
            item.result = "EMPTY";
          } else {
            item.result = result.data[0].replaceAll("<br>", "\n");
            item.promptResult = result.prompt;
          }

          item.loading = false;

          this.loadingSpeach = false;
        }).catch(() => {
          // Error de la generacion: parar el spinner. Con "EMPTY" la modal
          // muestra el Pitch del AM si existe (ccShowPitchFallback).
          item.result = "EMPTY";
          item.loading = false;
          this.loadingSpeach = false;
        });
        }else{
           item.loading = false;
            this.loadingSpeach = false;
        }
          
      });
    },

    getParsedMessage(message) {
      try {
        const parsed = JSON.parse(message);
        // Verificamos que sea un objeto y tenga la estructura esperada
        if (parsed && typeof parsed === 'object' && parsed.params) {
          return parsed;
        }
        return null;
      } catch (e) {
        return null; // No es JSON válido
      }
    },

    configModalMeeting(name, calendlyObject) {
      this.selectedTask = null;
      this.bdrNotificationId = null;
      this.bdrNotificationName = null;
      this.meeting = null;
      this.meeting = calendlyObject.meetingId;
      this.bdrNotificationName = calendlyObject.bdrTaskName;
      this.bdrNotificationId = calendlyObject.bdrTaskId;

      if(this.bdrNotificationName != null && this.bdrNotificationId != null){
        this.listOfTask.map(task => {
          if(task.task_owner_name == this.bdrNotificationName && task.id == this.bdrNotificationId){
              this.selectedTask = task.id;
            }
          }
        );
      }
      this.openModal(name);
    },

    listOfTasks(list){
      this.listOfTask = list.filter(task => task.notification_status_id == "2");
    },

    modifyMeeting(notification_id, link_event_id, link_id) {
      console.log("modifyMeeting", notification_id, link_event_id, link_id);
      bookersService.assignMeetingToBooker(notification_id, link_event_id, link_id).then((response) => {
        if(response.status == 200){
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 4000,
          });
          window.location.reload();
        }else{
          this.$swal({
            type: "error",
            html: this.$t("lang.general.error"),
            showCancelButton: false,
          });
        }
      });
    },
    
    // getLeadTasks(){
    //   const currentLinkId = this.opportunity_id;
    //   return notificationService.getTasks(currentLinkId).then((result) => {
    //     this.pendingtasks = result;
    //   });
    // },

    isOnyBilling() {
      return;
    },

    closeFormEvent(eventSaved = false) {
      //this.optionTask = 1;
      if (eventSaved) {
        this.eventSaveLoading = true;
        //const pendingTask = this.cantPendingTask - 1;
        const pendingTask =
          this.cantPendingTask > 0 ? this.cantPendingTask - 1 : 0;

        notificationService
          .closeTask(
            this.currentTask.id,
            pendingTask,
            this.currentTask.ref_id,
            this.optionTask
          )
          .then((res) => {
            this.eventSaveLoading = false;
            $("#dropdownMenuButton").dropdown("hide");

            //Si existe mas de una tarea pendiente para esta oportunidad.
            //Cierro todas esas tareas.
            if (this.listPendingTasks.length > 0) {
              let pendingTaskTemp = pendingTask;

              this.listPendingTasks.forEach((task) => {
                const currentTaskId = task.id;
                const opportunityId = task.ref_id;
                pendingTaskTemp = pendingTaskTemp > 0 ? pendingTaskTemp - 1 : 0;

                this.closeOtherTaks(
                  currentTaskId,
                  pendingTaskTemp,
                  opportunityId,
                  this.optionTask
                );
              });
            }
            this.nextTask();
          });
      } else {
        $("#dropdownMenuButton").dropdown("hide");
      }
    },

    hasValidEvent() {
      this.opportunity.events.forEach((event) => {
        if (event.event_id == 3) {
          this.events++;
        }
      });
      return this.events > 0;
    },

    closeOtherTaks(currentTaskId, pending, opportunityId, task_output) {
      notificationService
        .closeTask(currentTaskId, pending, opportunityId, task_output)
        .then((res) => {
        });
    },

    // checkOpportunityToTask(opportunityId){
    //     //const opportunityId = this.currentTask.ref_id;

    //     opportunitiesService.checkOpportunityToTask(opportunityId)
    //       .then( res => {
    //         const { check } = res;
    //         if( check === 'ok'){
    //           // Procesa la tarea
    //           console.log('check...', check)
    //           return true;
    //         } else {
    //           //Muestro mensaje de error
    //           console.log('check...', check)
    //           return false;
    //         }
    //       })
    // },

    async checkOpportunityToTask(opportunityId) {
      try {
        const res = await opportunitiesService.checkOpportunityToTask(
          opportunityId
        );
        const { result } = res;
        return result == "ok" ? true : false;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    async registerTask(value) {
      this.refreshButtonAI++
      this.contactsFiltered = this.getContactsFiltered()      
      if (value === 1) {
        // Option Meeting Booked
        this.optionTask = 1;
        this.eventSaveLoading = true;
        const pendingTask =
          this.cantPendingTask > 0 ? this.cantPendingTask - 1 : 0;

        //Reviso si esta oportunidad todavia puede ser procesada por el BDR o vencio el tiempo
        //El tiempo debe ser menos de 10 minutos desde que el bdr visualizo en su pantalla
        //la oportunidad para trabajar con las tareas
        //Caso contrario muestro mensaje indicando que esta oportunidad esta siendo procesada
        //por otro BDR si es asi el caso.

        const opportunityId = this.currentTask.ref_id;
        const hasPermissionToThisOpportunity =
          await this.checkOpportunityToTask(opportunityId);

        if (hasPermissionToThisOpportunity) {
          //console.log('yes.... registerTask 1');
          notificationService
            .closeTask(
              this.currentTask.id,
              pendingTask,
              this.currentTask.ref_id,
              value
            )
            .then((res) => {
              //console.log(res);
              this.eventSaveLoading = false;
              $("#dropdownMenuButton").dropdown("hide");

              //Si existe mas de una tarea pendiente para esta oportunidad.
              //Cierro todas esas tareas.
              if (this.listPendingTasks.length > 0) {
                let pendingTaskTemp = pendingTask;

                this.listPendingTasks.forEach((task) => {
                  const currentTaskId = task.id;
                  const opportunityId = task.ref_id;
                  pendingTaskTemp =
                    pendingTaskTemp > 0 ? pendingTaskTemp - 1 : 0;

                  this.closeOtherTaks(
                    currentTaskId,
                    pendingTaskTemp,
                    opportunityId,
                    value
                  );
                });
              }

              this.nextTask();
            });
        } else {
          $("#dropdownMenuButton").dropdown("hide");
          this.eventSaveLoading = false;
          this.$emit("getNextTask");
          //console.log("not pass...in registerTask");
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error_task"),
            showConfirmButton: true,
            confirmButtonText: this.$t("lang.button.ok"),
            allowOutsideClick: false,
          }).then(() => {
            //this.$emit('closeFormEvent', true);
          });
        }
      }

      if (value === 2) {
        // Option Call back
        this.optionTask = 2;
      }

      if (value === 3) {
        // Option no answer
        this.optionTask = 3;
      }

      if (value === 4) {
        // Option Phone
        this.optionTask = 4;
      }

      if (value === 6) {
        // Option ->  Neutral
        this.optionTask = 6;
      }

      if (value === 5) {
        // Option -> No interes...
        this.processOption(5)
      }     

      if (value === 7) {
        // Option -> Out of scope - contact
        this.processOption(7)
      }

      if (value === 8) {
        // Option -> Out of scope - company
        this.processOption(8)
      }

      if (value === 9) {
        // Option -> Wrong number
        this.processOption(9)
      }

      if (value === 10) {
        // Option -> Invalid number
        this.processOption(10)
      }
    },

    async processOption(value){

        this.optionTask = value;
        this.eventSaveLoading = true;
        const pendingTask =
          this.cantPendingTask > 0 ? this.cantPendingTask - 1 : 0;

        //Reviso si esta oportunidad todavia puede ser procesada por el BDR o vencio el tiempo
        //El tiempo debe ser menos de 10 minutos desde que el bdr visualizo en su pantalla
        //la oportunidad para trabajar con las tareas
        //Caso contrario muestro mensaje indicando que esta oportunidad esta siendo procesada
        //por otro BDR si es asi el caso.

        const opportunityId = this.currentTask.ref_id;
        const hasPermissionToThisOpportunity =
          await this.checkOpportunityToTask(opportunityId);

        if (hasPermissionToThisOpportunity) {
          //console.log('yes.... registerTask 5');
          notificationService
            .closeTask(
              this.currentTask.id,
              pendingTask,
              this.currentTask.ref_id,
              value
            )
            .then((res) => {
              //console.log(res);
              this.eventSaveLoading = false;
              $("#dropdownMenuButton").dropdown("hide");

              //Si existe mas de una tarea pendiente para esta oportunidad.
              //Cierro todas esas tareas.
              if (this.listPendingTasks.length > 0) {
                let pendingTaskTemp = pendingTask;

                this.listPendingTasks.forEach((task) => {
                  const currentTaskId = task.id;
                  const opportunityId = task.ref_id;
                  pendingTaskTemp =
                    pendingTaskTemp > 0 ? pendingTaskTemp - 1 : 0;

                  this.closeOtherTaks(
                    currentTaskId,
                    pendingTaskTemp,
                    opportunityId,
                    value
                  );
                });
              }
              this.nextTask();
            });
        } else {
          $("#dropdownMenuButton").dropdown("hide");
          this.eventSaveLoading = false;
          this.$emit("getNextTask");
          //console.log("not pass...in registerTask");
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error_task"),
            showConfirmButton: true,
            confirmButtonText: this.$t("lang.button.ok"),
            allowOutsideClick: false,
          }).then(() => {
            //console.log(');
          });
        }
    },

    isOnlyBilling() {
      //this.currentUser
      return (
        this.currentUser &&
        this.currentUser.role_id == 4 &&
        !this.currentUser.sales_representative_id
      );
    },

    // isBillingSale(){
    //   this.currentUser
    //   return this.currentUser && (this.currentUser.role_id == 4 && this.currentUser.sales_representative_id)
    // },

    getMoreTasks() {
      this.$emit("getNextTask");
    },
    nextTask() {
      this.$emit("selectNextTask");
    },

    taskSelected(task) {
      this.currentTask = task.currentTask;
      if (!this.currentTask) {
        this.selectedBusinessContact = this.opportunity.business_contacts[0]; // newVal[0];
      } else {
        const contact = this.opportunity.business_contacts.find(
          (el) => el.id == this.currentTask.business_contact_id
        );
        if (contact) {
          this.selectedBusinessContact = contact ? { ...contact } : null;
        } else {
          this.selectedBusinessContact = this.opportunity.business_contacts[0]; // newVal[0];
        }
      }

      //this.getSpeach(false);
      this.listPendingTasks = task.listPendingTasks;
      if (!this.currentTask) {
        this.$emit("selectNextTask");
      }
    },

    attachEventToThisOpportunity() {
      opportunitiesService
        .attachEventToThisOpportunity(this.linkIdToAttach, this.opportunity_id)
        .then((result) => {
          this.linkIdToAttach = "";
          if (result == "OK") {
            this.reloadOpportunity({
              headerTab: "NOTHING",
              link_id: this.opportunity_id,
            });
          }
        });
    },
    targetServiceLoadingCompleted() {
      this.loadingCompleted = true;
    },
    getlLink() {
      let sales_id = btoa(id);
      return "https://" + domain + "/calendar/" + sales_id;
      // // Obtener la ubicación actual del navegador
      // const location = window.location;

      // const baseUrl = `${location.protocol}//${location.host}`;

      // return `${baseUrl}/client-service-proposal/${this.selectedClientId}`;
    },

    copyToClipboard(text) {
      console.log("SI" + text);
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    validateCall() {
      return this.notcall;
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    openModalClaim(name){
      this.loadingOptionsClaims = true
      this.$modal.show(name);

       //get all optionsclaims
       opportunitiesService.getAllPossibleMeetings(this.opportunity_id)
      .then((response) => {

        if(response.length > 0){
          this.eventsToThisOpportunity = response
          this.loadingOptionsClaims = false
        } else {
          this.showMessageWithoutEvents = true;
          this.loadingOptionsClaims = false
        }          

      }).catch(error => {
        console.error("Error fetching options claims:", error);
        this.loadingOptionsClaims = false;  
      });

      //get all optionsclaims
      adminService.getAllOptionsClaims()
      .then((response) => {
          this.claimOptions = response
          this.addIncorrectOptionsClaim();
          this.loadingOptionsClaims = false
      }).catch(error => {
        console.error("Error fetching options claims:", error);
        this.loadingOptionsClaims = false;  
      });
    },

    addIncorrectOptionsClaim() {
      const fakeOptions = [
        { id: "Incorrect_1", title: "prospect_no_need_not_interested", is_active: "1" },
        { id: "Incorrect_2", title: "prospect_refuses_meeting_says_no_by_email", is_active: "1" },
        { id: "Incorrect_3", title: "forced_abusive_meeting", is_active: "1" },
        { id: "Incorrect_4", title: "prospect_not_decision_maker_wrong_level", is_active: "1" },
        { id: "Incorrect_5", title: "prospect_is_consultant_freelance", is_active: "1" },
        { id: "Incorrect_6", title: "direct_competition", is_active: "1" },
        { id: "Incorrect_7", title: "already_in_contact_parent_group_entity", is_active: "1" },
        { id: "Incorrect_8", title: "account_is_already_client", is_active: "1" },
        { id: "Incorrect_9", title: "incomplete_info_atypical_email", is_active: "1" },
        { id: "Incorrect_10", title: "different_company_size_societe_pappers", is_active: "1" },
        { id: "Incorrect_11", title: "absence_no_show", is_active: "1" }
      ];
      this.claimOptions = [...this.claimOptions, ...fakeOptions];
    },
    
    getDefaultEventsFromTo() {
      const now = new Date();
      const from = new Date(now.getTime() - 2 * 60 * 60 * 1000);
      const to = new Date(now.getTime() + 30 * 60 * 60 * 1000);
      return {
        from: this.formatDateTimeLocal(from),
        to: this.formatDateTimeLocal(to),
      };
    },
    formatDateTimeLocal(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${y}-${m}-${day}T${h}:${min}`;
    },
    async openManagerCalendarEvents() {
      const clientId = this.opportunity && this.opportunity.link && this.opportunity.link.client_id;
      this.managerEventsMonitorList = [];
      if (clientId != null) {
        try {
          const list = await monitorService.getMonitorList(clientId, { getGraphData: false }, 0);
          this.managerEventsMonitorList = Array.isArray(list) ? list : [];
        } catch (e) {
          this.managerEventsMonitorList = [];
        }
      }
      const opts = this.eventsModalSelectOptions;
      if (!opts || opts.length === 0) {
        this.$swal({
          type: "warning",
          title: "No options",
          text: "No users or contacts available to watch events.",
        });
        return;
      }
      this.selectedEventsOptionValue = opts[0].value;
      const defaults = this.getDefaultEventsFromTo();
      this.managerEventsFromDate = defaults.from;
      this.managerEventsToDate = defaults.to;
      this.$modal.show("managerCalendarEvents");
      this.fetchManagerCalendarEvents();
    },

    async fetchManagerCalendarEvents() {
      const selectedValue = this.selectedEventsOptionValue;
      const opt = this.eventsModalSelectOptions.find((o) => o.value === selectedValue);
      const userId = opt && opt.userId;
      if (userId == null) return;
      const now = new Date();
      const fromDate = this.managerEventsFromDate ? new Date(this.managerEventsFromDate) : new Date(now.getTime() - 2 * 60 * 60 * 1000);
      const toDate = this.managerEventsToDate ? new Date(this.managerEventsToDate) : new Date(now.getTime() + 30 * 60 * 60 * 1000);
      const fromTime = fromDate.getTime();
      const toTime = toDate.getTime();
      if (isNaN(fromTime) || isNaN(toTime)) return;
      const hoursBackRaw = (now.getTime() - fromTime) / (1000 * 60 * 60);
      const hoursForwardRaw = (toTime - now.getTime()) / (1000 * 60 * 60);
      const hoursBack = Math.round(Math.max(0, hoursBackRaw));
      const hoursForward = Math.round(Math.max(0, hoursForwardRaw));
      this.loadingManagerEvents = true;
      this.managerCalendarEvents = [];
      const eventsApi = this.currentUser.role_id === 1 ? adminService : bookersService;
      const params = {
        hours_back: hoursBack,
        hours_forward: hoursForward,
      };
      if (opt.useAccountId && opt.accountId) {
        params.account_id = opt.accountId;
      } else {
        params.user_id = userId;
      }
      try {
        const result = await eventsApi.getEventsByRange(params);
        if (result && result.success === false && result.error) {
          this.managerCalendarEvents = [];
          this.$swal({
            type: "error",
            title: "Error loading events",
            text: result.error,
          });
          return;
        }
        this.managerCalendarEvents = Array.isArray(result)
          ? result
          : (result && result.events) || (result && result.data) || [];
      } catch (err) {
        this.managerCalendarEvents = [];
        const errorMsg =
          (err && err.error) ||
          (err && err.message) ||
          "No events could be loaded.";
        this.$swal({
          type: "error",
          title: "Error",
          text: errorMsg,
        });
      } finally {
        this.loadingManagerEvents = false;
      }
    },

    openModal(name, simple = false) {
      if (
        this.opportunity !== undefined &&
        this.opportunity.timelinePassed !== undefined
      ) {
        if (!this.questions) {
          this.opportunity.timelinePassed.forEach((item, key) => {
            if (item.event_id == 3 && !this.eventid) {
              this.eventid = item.comment;
              calendlyService.getEvent(item.comment).then((result) => {
                this.questions = result.invitees[0];
              });
            }
          });
        }
        this.$modal.show(name);
      }

      if (simple) {
        this.$modal.show(name);
        this.loadingCompleted = false;
      }

      if (name == "aiscript") {
        this.refreshButtonAI++;
        this.loadColdCallScript(this.opportunity.link && this.opportunity.link.target_id);
        this.contactsFiltered = this.getContactsFiltered()
      }
    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    permissionFront() {
      return (
        this.currentUser.team_role_id == undefined ||
        this.currentUser.team_role_id != 3
      );
    },
    adminTeam() {
      return (
        this.currentUser.team_role_id != undefined &&
        this.currentUser.team_role_id == 2
      );
    },
    onlySales() {
      return (
        this.currentUser.team_role_id !== undefined &&
        this.currentUser.role_id == 3
      );
    },
    reloadOp() {
      this.reloadOpportunity({
        headerTab: "NOTHING",
        link_id: this.opportunity_id,
      });
    },
    reloadTasks() {
      this.tasksKey++;
    },
    setUserBDR() {
      const user = {
        user_id: this.user.id,
        name: this.user.name + " " + this.user.lastname,
        avatar: this.user.avatar,
      };

      opportunitiesService.setUserBDR(this.opportunity_id).then((response) => {
        if (response > 0) {
          this.setOpportunitySelected(user);
          this.tasksKey++;
        } else {
          this.$swal({
            type: "error",
            html: this.$t("lang.general.error"),
            showCancelButton: false,
          });
        }
      });
    },
    absentContact() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.startLoading();
          opportunitiesService
            .changeStatus(8, this.opportunity.link.id, 35)
            .then((opportunity) => {
              this.opportunity.link.link_status_id = 8;
              this.opportunity.link.link_status_reason_id = 35;
              this.finishLoading();
              this.$forceUpdate();
            })
            .catch(() => {
              this.finishLoading();
              this.$swal({
                type: "error",
                title: "Error",
                text: this.$t("lang.opportunities.absent"),
                showCancelButton: false,
              });
            });
        }
        this.closeModal("absent");
      });
    },
    closeRefuse() {
      this.refuse = false;
    },
    openRefuse() {
      this.refuse = true;
    },
    refused(claimReasonId, details) {
      this.opportunity.link.link_status_id = 8;
      this.opportunity.link.link_status_reason_id = 34;
      this.closeRefuse();
      adminService.autoCreateCancelClaim(this.opportunity.link.id, claimReasonId, details)
        .then(response => {
          if (response && response.id) {
            this.dispatchClaimJudge(response.id);
          }
        })
        .catch(() => {});
    },

    dispatchClaimJudge(claimId) {
      adminService.dispatchClaimJudge(claimId)
        .catch(error => {
          console.error("Error dispatching claim judge:", error);
        });
    },

    checkTasksandRemember(id) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.label.yesdonotcontactthem"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          opportunitiesService
            .setTaskandRemembers(id)
            .then((response) => {
              if (response === "ok") {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  text: this.$t("lang.label.datasavedsuccessfully"),
                  showConfirmButton: false,
                  timer: 4000,
                });
              } else {
                this.$swal({
                  type: "error",
                  title: this.$t("lang.general.error"),
                  showConfirmButton: false,
                  timer: 4000,
                });
              }
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: this.$t("lang.general.error"),
                showConfirmButton: false,
                timer: 4000,
              });
            });
        }
      });
    },

    disabledEsc() {
      document.addEventListener("keydown", function (e) {
        if (
          (e.key == "Escape" || e.key == "Esc" || e.keyCode == 27) &&
          e.target.nodeName == "BODY"
        ) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
      document.onkeydown = function (e) {
        if (e.keyCode === 27) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };
    },

    doNotContactBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.donotcontactthisbusiness"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.label.yesdonotcontactthem"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => { });
    },

    deleteBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.youaregoingtoclaimthisopportunity"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.label.yesclaimthisopportunity"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.startLoading();
          opportunitiesService
            .changeStatus(11, qualificationOptions.linkId)
            .then((opportunity) => {
              this.getAll({
                currentPage: "1",
                cantPerPage: "10",
                searchFilter: "",
              });
              this.$forceUpdate();
            });
        }
      });
    },

    valide() {
      this.$swal({
        type: "success",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.setasvalidopportunity"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          let linkStatusReasonId =
            (this.adminTeam() || this.permissionFront()) &&
              this.opportunity.link.link_status_reason_id == 35
              ? 38
              : null;
          //this.startLoading();
          opportunitiesService
            .changeStatus(8, this.opportunity_id, linkStatusReasonId)
            .then((opportunity) => {
              // this.finishLoading();
              this.reloadOpportunity({
                headerTab: "NOTHING",
                link_id: this.opportunity_id,
              });
            });
        }
      });
    },

    positiveBusiness(qualificationOptions) {
      this.$swal({
        type: "success",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.companytakecontrol"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          //this.startLoading();
          this.changeOpportunityStatus({
            link_id: qualificationOptions.linkId,
            link_status_name: "Positive",
          });
          opportunitiesService
            .changeStatus(
              8,
              qualificationOptions.linkId,
              qualificationOptions.statusReason
            )
            .then((opportunity) => {
              // this.finishLoading();
              this.reloadOpportunity({
                headerTab: "NOTHING",
                link_id: this.opportunity_id,
              });
            });
        }
      });
    },

    negativeBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.letolivertakecontrol"),
        text: this.$t("lang.label.olivertakecontrol"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.dismiss != "cancel") {
          opportunitiesService
            .changeStatus(
              5,
              qualificationOptions.linkId,
              qualificationOptions.statusReason,
              qualificationOptions.nextCampaignId,
              qualificationOptions.campaignDate
            )
            .then((opportunity) => {
              this.getAll({
                currentPage: "1",
                cantPerPage: "10",
                searchFilter: "",
              });
              this.$forceUpdate();
            });
        }
      });
    },
    unlockContacts(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.unlockcontactsfor"),
        text: this.$t("lang.label.byunlockingcontacts"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.dismiss != "cancel") {
          opportunitiesService
            .unlockContactsOpportunity(qualificationOptions.linkId)
            .then((opportunity) => {
              this.$forceUpdate();
            });
        }
      });
    },
    pendingTasks(cant) {
      this.cantPendingTask = cant;

      this.setTasks({ link_id: this.opportunity_id, tasks: cant });
      return true;
      this.opportunities.list.forEach((opp, key) => {
        if (opp.link_id == this.opportunity_id) {
          this.opportunities.list[key].tasks = cant;
          return true;
        }
      });
    },

    changeBusinessContactStatusByLinkId(options) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.thiscontactwillbeunsubscribedfromthiscampaignand"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          businessContactsService
            .changeStatusByLinkId(options.businessContactId, options.linkId, 7)
            .then((opportunity) => {
              this.reloadOpportunity({
                headerTab: "NOTHING",
                link_id: this.opportunity_id,
              });
            });
        }
      });
    },
    unsuscribeBusiness(options) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.allcontactspresentinthisopportunitywillbeunsubscribedfromthiscampaign"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          //connect to service
          this.startLoading();
          opportunitiesService
            .changeStatus(13, options.linkId)
            .then((opportunity) => {
              this.getAll({
                currentPage: "1",
                cantPerPage: "10",
                searchFilter: "",
              });
              this.$forceUpdate();
            });
        }
      });
    },

    unsubscribeContact(options) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.thiscontactwillbeunsubscribedfromthiscampaign"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          //connect to service
          businessContactsService
            .changeStatusContactUnsubscribe(
              options.businessContactId,
              options.linkId
            )
            .then((opportunity) => {
              this.reloadOpportunity({
                headerTab: "NOTHING",
                link_id: this.opportunity_id,
              });
            });
        }
      });
    },

    lateQualifiedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          7,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then((opportunity) => {
          this.getAll({
            currentPage: "1",
            cantPerPage: "10",
            searchFilter: "",
          });
          this.reloadOpportunity({
            headerTab: "NOTHING",
            link_id: this.opportunity_id,
          });
        });
    },

    busyOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          6,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then((opportunity) => {
          this.resetPriorityOpportunity();
          this.getPriorityOpportunity();
          this.reloadOpportunity({
            headerTab: "NOTHING",
            link_id: this.opportunity_id,
          });
        });
    },

    convertedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          9,
          qualificationOptions.linkId,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then((opportunity) => {
          this.getAll({
            currentPage: "1",
            cantPerPage: "10",
            searchFilter: "",
          });
          this.reloadOpportunity({
            headerTab: "NOTHING",
            link_id: this.opportunity_id,
          });
        });
    },

    lostOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          12,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then((opportunity) => {
          this.getAll({
            currentPage: "1",
            cantPerPage: "10",
            searchFilter: "",
          });
          this.reloadOpportunity({
            headerTab: "NOTHING",
            link_id: this.opportunity_id,
          });
        });
    },
    getLinkId() {
      let linkid = "linkid:";
      return btoa(linkid + this.opportunity.link.id);
    },

    convertBase64(txt) {
      return btoa(txt);
    },

changeBusiness() {
  this.openAiAnswers.forEach((el) => {
    el.result = "";
    el.promptResult = "";
    el.loading = false;
  });

  this.getSpeach(false);
},
    checkCalendly() {
      if (
        this.opportunity &&
        this.opportunity.campaignTokens &&
        this.opportunity.campaignTokens.my_calendar_link &&
        this.opportunity.campaignTokens.my_calendar_link.value &&
        this.opportunity.campaignTokens.my_calendar_link.value.includes(
          "calendly"
        )
      ) {
        // contiene "calendly"
        console.log("Es un enlace de Calendly");
        return true;
      } else {
        return false;
      }
    },
    convertTextToHtml(text) {
      let completeListText = "";

      if (text && text.length > 0) {
        const textWithLineBreaks = text.replace(/\n/g, "<br>");
        const textWithListItems = textWithLineBreaks.replace(/ - /g, "<li>");
        completeListText = `<ul>${textWithListItems}</ul>`;
      }

      return completeListText;
    },
  },
};
</script>

<style scoped>
.headerModalImg {
  width: 70px;
  height: 70px;
}

.bodyModalIcon {
  width: 25px;
  height: 25px;
}
.icantcall::selection {
  background: none;
  background-color: none;
  cursor: pointer;
}

.icantcall {
  cursor: pointer;
}

@media (min-width: 1920px) {
  .contentCenter {
    width: 100%;
  }
}

@media (min-width: 2560px) {
  .contentCenter {
    width: 90%;
  }
}

@media (min-width: 3840px) {
  .contentCenter {
    width: 70%;
  }
}

.dropdown-toggle::after {
  display: none !important;
}

.dropdown-menu-custom {
  width: 250px;
  /* Ancho personalizado del menú desplegable */
}

/* .show {
    display: block !important;
    opacity: 1;
  } */
.opportunity-left-unified-card {
  max-height: 900px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.opportunity-left-unified-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.opportunity-left-unified-scroll >>> .opportunity-admin-panel,
.opportunity-left-unified-scroll >>> .ol-left-panel {
  border: none;
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: none;
}

.opportunity-left-unified-scroll >>> .opportunity-admin-panel:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.opportunity-activity-column {
  max-height: 900px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.opportunity-actions-slot {
  flex-shrink: 0;
  margin-bottom: 0.5rem;
}

.opportunity-timeline-slot {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.scrollable-div {
  height: 455px;
}

.scrollable-div-section-3 {
  height: 510px;
}

.meeting-analysis-list {
  max-height: 520px;
  overflow-y: auto;
}

.meeting-analysis-content {
  max-height: 520px;
  overflow-y: auto;
}

.meeting-analysis-pre {
  max-height: 280px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f8f9fa;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
}

.coaching-result-body {
  font-size: 13px;
  line-height: 1.7;
  color: #1f2937;
}

.coaching-result-body .coaching-h {
  margin-top: 16px;
  margin-bottom: 6px;
  font-weight: 700;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 4px;
}

.coaching-result-body h3.coaching-h { font-size: 1rem; }
.coaching-result-body h4.coaching-h { font-size: 0.95rem; }
.coaching-result-body h5.coaching-h { font-size: 0.9rem; }

.meeting-transcript-chat {
  max-height: 460px;
  overflow-y: auto;
  padding: 12px 8px;
  background: #f7f8fa;
  border-radius: 8px;
}

.transcript-bubble-row {
  display: flex;
  margin-bottom: 8px;
}

.transcript-bubble-wrap {
  max-width: 85%;
  display: flex;
  flex-direction: column;
}

.transcript-speaker-label {
  font-size: 0.7rem;
  font-weight: 700;
  margin-bottom: 3px;
  padding-left: 4px;
  letter-spacing: 0.02em;
}

.transcript-bubble {
  padding: 8px 12px;
  border-radius: 0 10px 10px 10px;
  font-size: 0.875rem;
  line-height: 1.5;
  word-break: break-word;
  color: #1a1a2e;
}

.no-speaker-row {
  justify-content: center;
}

.no-speaker-bubble {
  background: #e9ecef !important;
  border-left: none !important;
  border-radius: 8px;
  color: #6c757d;
  font-style: italic;
  font-size: 0.8rem;
  padding: 4px 10px;
}
</style>
